import {AppState} from '../../../reducers/index';
import {createSelector} from '@ngrx/store';
import * as fromInstitutionReducer from './institution.reducer';
import {Institution} from './institution.model';
import {LanguagePipe} from "../../../../shared/pipes/language.pipe";

export const currentState = (state: AppState) => (state[fromInstitutionReducer.institutionsFeatureKey]);

export const selectAllInstitutions = createSelector(currentState, fromInstitutionReducer.selectAll);


export const selectModifiedInstitution = createSelector(selectAllInstitutions, (institutions) => {
  return institutions.map((institution) => {

    let name = new LanguagePipe().transform(institution?.institutionName, 'sw')
    if (new LanguagePipe().transform(institution?.institutionName, 'en')) {
      name += ` (${new LanguagePipe().transform(institution?.institutionName, 'en')})`
    }

    return {
      ...institution,
      name,
      value: institution?.institutionUniqueId,
      modInstitutionMinistry: institution?.institutionMinistry?.ministryName,
      modInstitutionSector: institution?.institutionSector?.sectorName
    };
  });
});


export const selectModifiedInstitutionByUniqueId= (uid: string) =>
  createSelector(selectModifiedInstitution, (institutions: Institution[]) => {
    return institutions.find((inst) => inst?.institutionUniqueId === uid);
  });
